// extracted by mini-css-extract-plugin
export default {"container":"Ge8fefb","content":"G453754 G74ffbd G9245dd G81a5ae","bottom":"Gadbdfe"};